interface MetricCardProps {
  label: string;
  value: number | string;
  format?: 'number' | 'percent' | 'compact';
  trend?: 'up' | 'down' | 'neutral';
  trendValue?: string;
  size?: 'sm' | 'md';
}

function formatValue(value: number | string, format?: string): string {
  if (typeof value === 'string') return value;

  switch (format) {
    case 'percent':
      return `${value}%`;
    case 'compact':
      if (value >= 1000000) return `${(value / 1000000).toFixed(1)}M`;
      if (value >= 1000) return `${(value / 1000).toFixed(1)}K`;
      return value.toLocaleString();
    default:
      return value.toLocaleString();
  }
}

export function MetricCard({
  label,
  value,
  format = 'number',
  trend,
  trendValue,
  size = 'md',
}: MetricCardProps) {
  const trendColors = {
    up: 'text-green-600',
    down: 'text-red-600',
    neutral: 'text-gray-500',
  };

  const trendIcons = {
    up: '↑',
    down: '↓',
    neutral: '→',
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-3 shadow-sm">
      <div className="text-xs text-gray-500 mb-1 truncate">
        {label}
      </div>
      <div className={`font-semibold text-gray-900 ${size === 'sm' ? 'text-lg' : 'text-2xl'}`}>
        {formatValue(value, format)}
      </div>
      {trend && trendValue && (
        <div className={`text-xs mt-1 ${trendColors[trend]}`}>
          {trendIcons[trend]} {trendValue}
        </div>
      )}
    </div>
  );
}
